import { render, staticRenderFns } from "./OrderDetailComponent.vue?vue&type=template&id=cb1e04a0"
import script from "./OrderDetailComponent.vue?vue&type=script&lang=js"
export * from "./OrderDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailComponent.vue?vue&type=style&index=0&id=cb1e04a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports